import React from 'react';
import times from 'lodash/times';
import { ModalBody } from '../CommonComponents/OPL/Modal/ModalBody';
import { Shimmer } from '../CommonComponents/OPL/Shimmer/Shimmer';
import { ModalFooter } from '../CommonComponents/OPL/Modal/ModalFooter';
import { ContentWrapper } from '../ClientGetStartedModal/ClientGetStartedModal.styles';

interface Props {
  isInitialSetup?: boolean;
}

export const TwoFactorAuthenticationLoading = ({ isInitialSetup }: Props) => {
  const Wrapper = isInitialSetup ? ContentWrapper : ModalBody;

  return (
    <>
      <Wrapper>
        <Shimmer height={16} />
        {times(4).map((key, index) => (
          <Shimmer
            key={key}
            height={index % 2 ? 40 : 16}
            width={index % 2 ? '100%' : 120}
            mt={16}
          />
        ))}
      </Wrapper>

      <ModalFooter>
        <Shimmer height={36} width={65} mr={12} />
        <Shimmer height={36} width={65} />
      </ModalFooter>
    </>
  );
};
